(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/stream-player/assets/javascripts/helpers/stream-player-data-helper.js') >= 0) return;  svs.modules.push('/components/racing/stream-player/assets/javascripts/helpers/stream-player-data-helper.js');
"use strict";

(function (svs) {
  'use strict';

  const fetchLiveStreamSessionToken = svs.racing.streamingService.fetchLiveStreamSessionToken;
  const fetchRacecardNext = svs.racing.raceService.fetchRacecardNext;
  const getRaceDiscipline = svs.racing.common.strings.getRaceDiscipline;
  const fetchPlayList = svs.racing.streamingService.fetchPlayList;
  const defaultThumbnail = '/images/racing/stream-player/stream-placeholder-v3.jpg';
  svs.racing.streamplayer.StreamPlayerDataHandler = {
    getSessionToken(options, callback) {
      const returnValues = {
        hasError: false,
        sessionToken: undefined
      };
      fetchLiveStreamSessionToken(options, (err, data) => {
        if (err) {
          returnValues.hasError = true;
        } else {
          returnValues.sessionToken = data.sessiontoken;
        }
        callback(returnValues);
      });
    },
    getPlayList(options, callback) {
      const returnValues = {
        hasError: false,
        assetId: undefined,
        thumbnailSrc: defaultThumbnail,
        sessionToken: undefined
      };
      fetchPlayList(options).then(result => {
        returnValues.hasError = false;
        returnValues.assetId = result.assetId;
        returnValues.thumbnailSrc = result.thumbnailSrc || defaultThumbnail;
        callback(returnValues);
      }).catch(() => {
        returnValues.hasError = true;
        callback(returnValues);
      });
    },
    getRacecardData(callback) {
      const returnValues = {
        hasError: false,
        raceCard: undefined
      };
      fetchRacecardNext((err, data) => {
        if (err) {
          returnValues.hasError = true;
          callback(returnValues);
        } else {
          returnValues.hasError = false;
          const startType = data.startType ? "| ".concat(data.startType.charAt(0).toUpperCase() + data.startType.slice(1)) : '';
          data.description = "".concat(getRaceDiscipline(data.raceDiscipline), " ").concat(startType, " | ").concat(data.distanceString);
          returnValues.raceCard = data;
          callback(returnValues);
        }
      });
    }
  };
})(svs);

 })(window);